import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Globalni fetch interceptor za 401 (istekla sesija)
const originalFetch = window.fetch;
let isHandling401 = false;
window.fetch = async (input, init) => {
  const response = await originalFetch(input, init);

  try {
    // Detekcija da li je zahtjev bio autentificiran (ima token ili Authorization header)
    const hasToken = (() => { try { return !!localStorage.getItem('token'); } catch { return false; } })();

    const hasAuthHeader = (() => {
      try {
        // Ako je input Request objekat
        if (input && typeof input === 'object' && typeof input.url === 'string' && typeof input.headers?.get === 'function') {
          const hdr = input.headers.get('Authorization');
          if (hdr) return true;
        }
        // Ako su headeri u init objektu
        if (init?.headers) {
          const h = init.headers;
          if (typeof h.get === 'function') {
            return !!h.get('Authorization');
          } else if (typeof h === 'object') {
            const keys = Object.keys(h);
            const key = keys.find(k => k.toLowerCase() === 'authorization');
            return key ? !!h[key] : false;
          }
        }
      } catch {}
      return false;
    })();

    if (response.status === 401 && (hasToken || hasAuthHeader) && !isHandling401) {
      isHandling401 = true;

      // Fiksna poruka za isteklu sesiju
      const message = 'Sesija je istekla - prijavite se ponovo';

      try {
        // Očisti lokalnu sesiju
        try { localStorage.removeItem('token'); } catch {}
        try { localStorage.removeItem('user'); } catch {}

        // Prikaži poruku korisniku i preusmjeri na login
        alert(message);
        window.location.href = '/login';
      } catch {
        window.location.href = '/login';
      }
    }
  } catch {
    // Ako dođe do greške u interceptoru, samo vrati response
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
